if (!customElements.get('alc-valeurs-marque')) {
  class AlcValeursMarque extends HTMLElement {
    constructor() {
      super();
      this.carousel = null;
    }

    connectedCallback() {
      this.initCarousel();
    }

    initCarousel() {
      const carouselElement = this.querySelector('.alc-valeurs-marque__products');
      if (!carouselElement) return;

      if (typeof Flickity === 'undefined') {
        setTimeout(() => this.initCarousel(), 100);
        return;
      }

      this.carousel = new Flickity(carouselElement, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        groupCells: true,
        wrapAround: false,
        cellSelector: '.alc-valeurs-marque__product-card'
      });

      this.initArrows();
      this.resizeOnImagesLoad(carouselElement);
    }

    resizeOnImagesLoad(carouselElement) {
      const images = Array.from(carouselElement.querySelectorAll('img'));
      const unloaded = images.filter(img => !img.complete);
      if (unloaded.length === 0) return;
      Promise.all(unloaded.map(img => new Promise(resolve => {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      }))).then(() => {
        if (this.carousel) this.carousel.resize();
      });
    }

    initArrows() {
      const prevBtn = this.querySelector('.alc-valeurs-marque__arrow-btn--prev');
      const nextBtn = this.querySelector('.alc-valeurs-marque__arrow-btn--next');

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          this.carousel.previous();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          this.carousel.next();
        });
      }
    }

    disconnectedCallback() {
      if (this.carousel) {
        this.carousel.destroy();
      }
    }
  }

  customElements.define('alc-valeurs-marque', AlcValeursMarque);
}